<template>
	<div class="header">
		<div class="header-left">
			<SysHeader sysnameColor="#fff" :sysNameOfCn="appStore.sysNameOfCn" />
		</div>
		<div class="header-right v-c">
			<UserHeader />
		</div>
	</div>
</template>

<script lang="ts" setup>
import { useAppStore } from '@/store/app'
import UserHeader from './UserHeader/index.vue'
import SysHeader from '@/views/login/components/SysHeader.vue'

const appStore = useAppStore()
</script>

<style lang="scss" scoped>
.header {
	position: relative;
	z-index: 1;
	@include v-c;
	justify-content: space-between;
	height: $header-height;
	line-height: $header-height;
	&-left {
		margin-left: -20px;
		padding: 0 20px 0 90px;
		width: 400px;
		background: url('@/assets/images/bg-head.png') no-repeat 100% 100%;
	}
}
</style>
